import classNames from 'classnames';

export type FilterTab = {
	name: string;
	count?: number;
}
export type FilterTabsProps = {
	filterTabs: FilterTab[];
	selectedColor: string; // use tailwind syntax ex: border-red-400
	selectedTab: number; // index of the selected tab
	setSelectedTab: (index: number) => void;
}

export const FilterTabs = (props: FilterTabsProps) => {

	const getTabName = (tab: FilterTab) => {
		return tab.count ? `${tab.name} (${tab.count})` : tab.name;
	}

	return (
		<div className="flex flex-row flex-grow w-full">
			{
				props.filterTabs.map((item: FilterTab, index) => {
					if (item.name) {
						return (
							<div key={index}
								className={classNames(
									`flex mb-8 text-center flex-col flex-grow w-full cursor-pointer border-b-2`,
									props.selectedTab === index ? `${props.selectedColor} font-semibold` : "border-secondary-blue",
								)}
								onClick={() => props.setSelectedTab(index)}
							>
								<p className={`ml-6 uppercase text-gray-800 mb-2`}
								>{getTabName(item)}</p>
							</div>
						)
					} else {
						return (
							<div key={index} />
						)
					}
				})
			}
		</div>
	)
}
